"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChangeIconDialogModule = /** @class */ (function () {
    function ChangeIconDialogModule() {
    }
    return ChangeIconDialogModule;
}());
exports.ChangeIconDialogModule = ChangeIconDialogModule;
